// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import KycReview from "../../models/kyc-review.model";
import { PortfoliosListApiResponse } from "../login/types";

class OnlineTradingService {
  private dispatch = useDispatch();

  public async getOnlineTradingListData(
    status: string[],
    all = false,
    page,
    searchWord,
    sortField,
    sortOrder,
    filters: any,
    source?: string[],
  ): Promise<
    | {
      data: PortfoliosListApiResponse;
      message: string;
    }
    | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20&onlineTrading=true`;

    if (all) query += "&all=true";

    if (searchWord) {
      query += `&search=${searchWord}`;
    }
    if (sortField) {
      query += `&sortField=${sortField}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }
    if (filters?.length && filters != "null") {

      JSON.parse(filters)?.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&status[${index}]=${element}`;
        } else {
          query += `&status[${index}]=${element}`;
        }
      });
    } else {
      status.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&status[${index}]=${element}`;
        } else {
          query += `&status[${index}]=${element}`;
        }
      });
    }

    if (source?.length) {
      source.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&source[${index}]=${element}`;
        } else {
          query += `&source[${index}]=${element}`;
        }
      });
    }

    try {
      const response: AxiosResponse<{
        data: PortfoliosListApiResponse;
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio${query}`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/online-trading-access");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async toggleTradingAccess(portfolioId: number, isTradingAllowed: boolean): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/${portfolioId}/update-portfolio-capabilities`, {
        isTradingAllowed,
        enabledMarkets: [
          "NASDAQ",
          "NYSE",
          "KSE"
        ],
      });
      toast.success("Trading access updated successfully");
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/online-trading-access`);
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default OnlineTradingService;
